import { gql } from '@apollo/client';

const getPromotion = gql`
  query GetPromotion(
    $code: String!
    $bookingType: BookingTypeEnum!
    $bookingDate: Date!
    $amount: Int!
    $nursery: UUID
    $supplier: UUID
  ) {
    promotionForGuardians(
      code: $code
      bookingType: $bookingType
      bookingDate: $bookingDate
      amount: $amount
      nursery: $nursery
      supplier: $supplier
    ) {
      id
      finalAmount
      discount
      originalAmount
    }
  }
`;

export default getPromotion;
